import { Injectable } from '@angular/core';
import { VerfahrenFacade, VerfahrenResource } from '@schir-int-client/verfahren-shared';
import { isNil } from 'lodash-es';
import { EipConnection, EipMessageListener } from './eip.connection';
import { EipMessages } from './eip.messages';
import { EipConfig } from '@schir-int-client/api-root';

@Injectable({ providedIn: 'root' })
export class EipLawsuit implements EipMessageListener {
	verfahren: VerfahrenResource;

	aktenzeichenOfActiveLawsuit: string;
	lastRequestedAktenzeichen: string;
	private config: EipConfig;

	constructor(
		private connection: EipConnection,
		private verfahrenFacade: VerfahrenFacade
	) {}

	init(eipConfig: EipConfig) {
		this.config = eipConfig;
		this.connection.addMessageListener(this);
		this.verfahrenFacade.verfahrenSingle.subscribe(verfahrenSingle => {
			if (
				!isNil(verfahrenSingle) &&
				!verfahrenSingle['implicitlySpecified'] == true &&
				verfahrenSingle.stammdaten.aktenzeichen != this.aktenzeichenOfActiveLawsuit
			) {
				this.verfahren = verfahrenSingle;
				this.sendActivateLawsuitContextRequest(verfahrenSingle.stammdaten.aktenzeichen);
			}
			// it is not possible to deactivate or leave the lawsuit context without activating a new one.
		});
	}

	public sendActivateLawsuitContextRequest(aktenzeichen: string) {
		this.connection.sendMessage(EipMessages.activateLawsuitContextRequest(aktenzeichen, this.config));
	}

	public onMessage(messageName: string, messageObj: any, id: string) {
		switch (messageName) {
			case 'ActivateLawsuitContextResponse':
				this.onActivateLawsuitContextResponse(messageObj);
				break;
			// TODO: diese ganze Behandlung entfernen, sobald Integration läuft:
			case 'GetLawsuitRequest':
				const request: GetLawsuitRequest = <GetLawsuitRequest>messageObj;
				console.error('Diese Message hätte nicht an das Frontend gesendet werden dürfen!');
				console.log('message object: %o', messageObj);
				console.log('message json: %o', request.LawsuitId);

				this.connection.sendMessageWithId(id, EipMessages.getLawsuitResponse(this.verfahren, this.config));
				break;
			default:
				console.log('eIP-Lawsuit: unknown message type: ' + messageName);
		}
	}

	public supportedMessageNames(): string[] {
		return ['ActivateLawsuitContextResponse', 'GetLawsuitRequest'];
	}

	private onActivateLawsuitContextResponse(messageObj: any) {
		console.log('onActivateLawsuitContextResponse: ' + messageObj);
		// Achtung: Laut Schema enthält die Antwort keine ID des Verfahrens oder der Lawsuit. Daher wird geraten,
		// dass die Antwort zum zuletzt gestellten Request gehört.
		this.aktenzeichenOfActiveLawsuit = this.lastRequestedAktenzeichen;
	}
}

interface GetLawsuitRequest {
	LawsuitId: string;
	ExecutionContext: any;
}

// TODO: wahrscheinlich zu löschen, da diese Response durch das Backend erzeugt und gesendet werden muss.
interface GetLawsuitResponse {
	Result: GetLawsuitResult;
}

interface GetLawsuitResult {
	Lawsuit: Lawsuit;
}

interface Lawsuit {
	Id: string;
	Name: string;
	OrganizationalEntity: OrganizationalEntity;
}

interface OrganizationalEntity {}
